<div class="wrapper-modal add-invitation-images">
  <form [formGroup]="editInvitationForm" (ngSubmit)="onSubmitEditInvitationForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">{{modalTitle}}</span>
    </div>

    <div class="content-modal">
      <div class="grid__m-12">
        <div class="wrapper-custom-gallery">
          <div class="header-custom-gallery">
            <span class="title-gallery">{{galleryTitle}}</span>
            <div class="wrapper-btn-gallery">
              <div class="file-input">
                <input
                  #fileInput
                  type="file"
                  [accept]="acceptedFileTypes"
                  name="file-input"
                  id="file-input"
                  class="file-input__input"
                  multiple
                  (change)="onFileChange($event)"
                />
                <label class="file-input__label" for="file-input"><span>{{addButtonLabel}}</span></label>
              </div>
              <button (click)="removeAllMedia()" class="zc-btn zc-btn--delete" type="button">
                <span>{{deleteAllLabel}}</span>
              </button>
            </div>
          </div>

          <div class="content-custom-gallery">
            <div class="wrapper-gallery-images">
              <div
                *ngIf="mediaItemsForEdit.length"
                cdkDropList
                class="grid media-modal-grid"
                (cdkDropListDropped)="dropMediaItem($event)"
              >
                <div
                  *ngFor="let mediaItem of mediaItemsForEdit"
                  cdkDrag
                  class="wrapper-gallery-image"
                  [ngClass]="{'video-gallery-image': mediaItem.type === 'video'}"
                >
                  <img *ngIf="mediaItem.type === 'image' && mediaItem.fullPath" [src]="mediaItem.fullPath" [alt]="mediaItem.name">
                  <div *ngIf="mediaItem.type === 'image' && !mediaItem.fullPath" class="gallery-placeholder"></div>
                  <img
                    *ngIf="mediaItem.type === 'video' && mediaItem.posterPath"
                    [src]="mediaItem.posterPath"
                    [alt]="mediaItem.name"
                  >
                  <video
                    *ngIf="mediaItem.type === 'video' && !mediaItem.posterPath && mediaItem.fullPath"
                    [src]="mediaItem.fullPath"
                    muted
                  ></video>
                  <div *ngIf="mediaItem.type === 'video' && !mediaItem.fullPath" class="gallery-placeholder video-placeholder">
                    <i class="fa-solid fa-play"></i>
                  </div>
                  <button
                    *ngIf="mediaItem.type === 'video' && mediaItem.fullPath"
                    type="button"
                    class="video-play-button"
                    (click)="openVideoPreview(mediaItem); $event.stopPropagation()"
                    [attr.aria-label]="'Pusti video ' + mediaItem.name"
                  >
                    <i class="fa-solid fa-play"></i>
                  </button>
                  <!-- <span class="media-position">{{mediaItem.position}}</span> -->
                  <span class="media-title">{{mediaItem.name}}</span>
                  <span class="icon-delete" (click)="removeSingleMedia(mediaItem)">
                    <i class="fa-regular fa-trash-can"></i>
                  </span>
                </div>
              </div>

              <div *ngIf="!mediaItemsForEdit.length" class="empty-media-modal-state">
                <span>{{emptyMediaMessage}}</span>
              </div>
            </div>
          </div>

          <span class="error-message">{{editInvitationForm.controls.media | formControlErrorMessages: null : formTriedToSubmit}}</span>
        </div>
      </div>
    </div>

    <div class="footer-modal">
      <button class="zc-btn zc-btn--gray" type="button" (click)="closeModal.emit()"><span>Zatvori</span></button>
      <button class="zc-btn zc-btn--primary zc-position-relative" [disabled]="isLoaderActive" type="submit">
        <gr-loader *ngIf="isLoaderActive" [isButtonLoader]="true"></gr-loader>
        <span>Sacuvaj</span>
      </button>
    </div>
  </form>

  <div *ngIf="previewVideoItem" class="video-preview-modal-backdrop" (click)="closeVideoPreview()">
    <div class="video-preview-modal" (click)="$event.stopPropagation()">
      <div class="video-preview-modal-header">
        <span>{{previewVideoItem.name}}</span>
        <button type="button" (click)="closeVideoPreview()" aria-label="Zatvori preview">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <video
        *ngIf="previewVideoItem.fullPath"
        [src]="previewVideoItem.fullPath"
        controls
        autoplay
      ></video>
    </div>
  </div>
</div>
